import styles from './datesLoadingSkeleton.module.scss';

const sections = ['start', 'deadlines', 'finish'];

export const DatesLoadingSkeleton = () => (
  <div
    className={styles.datesLoadingSkeleton}
    data-testid='dates-loading-skeleton'
    aria-busy='true'
    aria-label='Loading project dates'
  >
    {sections.map((section) => (
      <section key={section} className={styles.section} data-testid='dates-section-skeleton'>
        <div className={styles.heading} aria-hidden='true' />
        <div className={styles.fields}>
          {Array.from({ length: 4 }, (_, index) => (
            <div
              key={`${section}-${index}`}
              className={styles.field}
              data-testid='dates-field-skeleton'
              aria-hidden='true'
            >
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
          ))}
        </div>
      </section>
    ))}
  </div>
);
